(function () {

    "use strict";

    function LogoutController(idsrvResourceOwnerService, currentUser, $state, vistautilsFactory, signalrFactory, $rootScope) {

        var vm = this;
        vm.vu = vistautilsFactory;
        vm.username = currentUser.profile.userName;
        vm.logout = logout;

        function logout() {

            // Cerramos la conexion de SignalR.
            signalrFactory.desconectar();

            //Eliminamos colores de los levels
            $rootScope.colorsToLevels = [];

            idsrvResourceOwnerService.revokeToken(currentUser.profile.token)
                .then(function () {
                    currentUser.clear();
                    //$rootScope.masterPage = "generic";
                    vm.vu.masterPage("generic");
                    $state.go("login");
                })
                .catch(function () {
                    // Show error   
                })
                .finally(function () {
                    vm.loading = false;
                });
        }

    }

    LogoutController.$inject = ["sphForms.idsrvResourceOwnerService", "sphForms.currentUser", "$state", "sphforms.vistautilsFactory", "sphforms.signalrFactory","$rootScope"];

    angular.module("sphForms.auth")
        .component("sphFormsLogout", {
            controller: LogoutController,
            templateUrl: "modules/auth/components/logout/logout.template.html"
        });

}());
